import { Pager } from "../common/pagination.model";

export interface Shipping {
  id: string;          // or number, depending on backend
  name: string;
  slug: string;
  is_active: boolean;
  has_api: boolean;
  delivery_key: string;
  createdAt: string;   // can also use Date if you parse it
}

export interface ShippingCompanyResponse extends Pager {
  records: Shipping[];
}

export interface ShippingCompanyForm {
  companyName: string;
  companyNameSlug: string;
  deliveryKey: string;
  status: boolean;
  hasAPI: boolean;
}
export interface ShippingMethodResponse extends Pager {
  records: ShippingMethodAdmin[];
}

export interface ShippingMethodAdmin {
  id: string;           // or number, depending on backend
  name: string;
  method_code: string;
  shipping_fee: number; // keep as string if backend sends string
  min_cart_total: number;
  is_required: boolean;
  is_active: boolean;
  standard_fee: number;
  createdAt: string;    // ISO date string, can also be Date
}